import { render } from "./shopStaffManage.vue?vue&type=template&id=0f60a5c4"
import script from "./shopStaffManage.vue?vue&type=script&lang=js"
export * from "./shopStaffManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__